import Page from '../../components/Page/Page';
import { useAuth } from '../../contexts/AuthProvider';
import { useI18n } from '../../contexts/I18nProvider';
import useCompany from '../../hooks/useCompany';
import { BuiltInPermissions, ScopeEnum } from '../../types/api/response/role';
import { DocumentPropertySpace } from '../../types/types';
import { hasPermission } from '../../utils/authorization';
import DocumentsTable from './components/DocumentsTable';

export default function DocumentsPersonal() {
  const { t } = useI18n();
  const { user } = useAuth();
  const { id: companyId } = useCompany(user);

  return (
    <Page title={t('w.personalDocuments')} parent={{ label: user.fullname! }}>
      <DocumentsTable
        hasPermissionToEditSpace={hasPermission(
          {
            permission: BuiltInPermissions.AuthorizedEditMyPersonalSpace,
            scope: ScopeEnum.ALL,
          },
          user,
          companyId
        )}
        space={DocumentPropertySpace.PERSONAL}
        userId={user.id}
        companyId={companyId}
        accountantCompanyId={null}
      />
    </Page>
  );
}
